import React from "react";
import "./contentMessage.scss";

import MoreVertIcon from "@mui/icons-material/MoreVert";

import { t } from "i18next";
import { Button, Dropdown } from "react-bootstrap";
import { isEmpty } from "../../../../utils/validation";

const ContentMessage = ({ dataNotification }) => {
  return !isEmpty(dataNotification) ? (
    <div className="notification-details-container container-on-right mt-3">
      <div className="header-notification">
        <div className="association-info">
          <img
            className="image-profile"
            src={
              "data:" +
              dataNotification.image_type +
              ";base64," +
              dataNotification.image
            }
            alt="associazione"
          />
          <div className="name-association">
            {dataNotification.name_association}
          </div>
        </div>
        <div className="menu-icon">
          <Dropdown>
            <Dropdown.Toggle
              as="button"
              variant="light"
              id="dropdown-menu"
              className=" bg-transparent border-0 p-0"
            >
              <MoreVertIcon />
            </Dropdown.Toggle>
            <Dropdown.Menu style={{ zIndex: 2 }}>
              <Dropdown.Item disabled>
                {dataNotification.datetime_sending}
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>
      <div className="content-notification mt-3">
        <div className="title-notification">{dataNotification.title}</div>
        <p className="body-notification mt-2">{dataNotification.body}</p>
      </div>
    </div>
  ) : null;
};

export default ContentMessage;
